// Lazy load function
const lazyLoad = (file) => () =>
    import(/* webpackChunkName: "[request]" */ `@/views/finance/gl-accounts/${file}.vue`);

export default [
    // GLAccounts
    {
        path: "/gl-accounts",
        name: "gl-accounts",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "GlAccounts",
        },
        components: {
            content: lazyLoad("gl-account"),
        },
    },
    {
        path: "/gl-accounts/review/:id",
        name: "gl-accounts-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "GlAccounts",
        },
        components: {
            content: lazyLoad("gl-account"),
        },
    },
    {
        path: "/gl-accounts/edit/:id",
        name: "gl-accounts-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "GlAccounts",
        },
        components: {
            content: lazyLoad("gl-account"),
        },
    },
    {
        path: "/gl-accounts/create",
        name: "gl-accounts-Create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "GlAccounts",
        },
        components: {
            content: lazyLoad("gl-account"),
        },
    },
];